import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonComponents } from './ProviderButtons';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { AuthParamKeys } from '~/models/Auth/AuthParamModel';
import { ProviderType } from './constants';

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(14),
    margin: theme.spacing(2, 'auto'),
  },
  divider: {
    width: '100%',
    maxWidth: 300,
    margin: theme.spacing(1, 'auto'),
  },
}));

interface Props {
  signup?: boolean;
  authParams: { [key in AuthParamKeys]: string };
  lastLoginProvider: ProviderType;
}

const LastLoginButton = ({ signup, authParams, lastLoginProvider }: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const ButtonComponent = ButtonComponents[lastLoginProvider];
  return (
    <>
      <Typography className={classes.text}>
        {t('logins.providers.lastProvider')}
      </Typography>
      <ButtonComponent signup={signup} authParams={authParams} />
      <Divider classes={{ root: classes.divider }} />
      <Typography className={classes.text}>
        {t('logins.providers.otherProviders')}
      </Typography>
    </>
  );
};

export default LastLoginButton;
